import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

const AddParticipant = () => {
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const [quizid, setQuizid] = useState("");
  const [participants, setParticipants] = useState("");
  const [errMsg, setErrMsg] = useState("");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setQuizid(localStorage.getItem("quizid"));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrMsg("");
    setSuccess(false);
    setLoading(true);

    try {
      const response = await axiosPrivate.post(
        "/manager/addparticipant",
        JSON.stringify({
          quizid,
          participants: participants.split(",").map((p) => p.trim()),
        })
      );
      setLoading(false);
      setSuccess(true);
      setParticipants("");
    } catch (err) {
      setLoading(false);
      console.error(err);
      setErrMsg(err?.response?.data?.message || err?.message);
    }
  };

  const emailCount = participants.trim() ? participants.split(",").filter(p => p.trim()).length : 0;

  return (
    <div className="fade-in" style={{ maxWidth: "800px", margin: "0 auto", padding: "2rem 1rem" }}>
      {/* Back Button */}
      <button
        className="btn-secondary"
        style={{ marginBottom: "1.5rem", padding: "0.5rem 1rem", fontSize: "0.875rem" }}
        onClick={() => navigate("/manager/quizdetails")}
      >
        ← Back to Quiz Details
      </button>

      {/* Header */}
      <div style={{ marginBottom: "2rem", textAlign: "center" }}>
        <h1
          style={{
            fontSize: "2.5rem",
            fontWeight: "700",
            marginBottom: "0.5rem",
            background: "linear-gradient(135deg, var(--primary-purple-light), var(--accent-cyan))",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
          }}
        >
          Add Participants
        </h1>
        <p style={{ color: "var(--text-muted)", fontSize: "1.125rem" }}>
          Invite participants to this quiz via email
        </p>
      </div>

      {/* Messages */}
      {errMsg && <p className="errmsg">{errMsg}</p>}
      {success && (
        <div className="successmsg" style={{ textAlign: "center" }}>
          <p style={{ marginBottom: "1rem" }}>✓ Participants added successfully!</p>
          <button
            className="btn-primary"
            onClick={() => navigate("/manager/quizdetails")}
            style={{ marginTop: "0.5rem" }}
          >
            Back to Quiz Details
          </button>
        </div>
      )}

      {/* Form Card */}
      {!success && (
        <div className="card" style={{ padding: "2.5rem" }}>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="participants">
                Participant Email Addresses
              </label>
              <textarea
                id="participants"
                value={participants}
                onChange={(e) => setParticipants(e.target.value)}
                placeholder="user1@example.com, user2@example.com, user3@example.com"
                required
                rows="6"
                disabled={loading}
              />
              <p className="instructions">
                📧 Enter email addresses separated by commas
                {emailCount > 0 && ` • ${emailCount} email${emailCount !== 1 ? 's' : ''} detected`}
              </p>
            </div>

            <div style={{ marginTop: "2rem", display: "flex", gap: "1rem" }}>
              <button
                type="submit"
                className="btn-primary"
                style={{ flex: 1 }}
                disabled={loading || !participants.trim()}
              >
                {loading ? "Adding..." : `Add ${emailCount || ''} Participant${emailCount !== 1 ? 's' : ''}`}
              </button>
              <button
                type="button"
                className="btn-secondary"
                onClick={() => navigate("/manager/quizdetails")}
                style={{ flex: 1 }}
                disabled={loading}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      )}

      {loading && (
        <div style={{ textAlign: "center", marginTop: "2rem", color: "var(--text-muted)" }}>
          <div className="pulse" style={{ fontSize: "2rem", marginBottom: "0.5rem" }}>⏳</div>
          <p>Adding participants...</p>
        </div>
      )}
    </div>
  );
};

export default AddParticipant;
